import{t as e}from"../../../../_virtual/index12.js";!function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=/(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;t.default=a,e.exports=t.default}(e,e.exports);
//# sourceMappingURL=index.js.map
